import { useDimensionsContext } from '../Chart'

export const XAxis = ({ x }) => {
  const xTicks = [
    new Date('0010-01-02'),
    new Date('0015-01-02'),
    new Date('0020-01-02')
  ]

  const dimensions = useDimensionsContext()
  return (
    <g className="axis" transform={`translate(0, ${dimensions.boundedHeight})`}>
      {xTicks.map((tick, i) => {
        return (
          <g
            key={tick}
            style={{
              transform: `translate(${x(tick)}px, 0)`
            }}
          >
            <text y={10} dy="0.71em">
              {`20${tick.getFullYear()}`}
            </text>
          </g>
        )
      })}
    </g>
  )
}

export const YAxis = ({ y }) => {
  const dimensions = useDimensionsContext()

  const yTicks = [2, 3, 4]

  return (
    <g className="axis vertical">
      {yTicks.map((tick, i) => {
        return (
          <g
            key={tick}
            style={{
              transform: `translate(0, ${y(tick)}px)`
            }}
          >
            <line className="solid-line" x2={dimensions.boundedWidth} />
            <text x={-30}>{tick + '%'}</text>
          </g>
        )
      })}
    </g>
  )
}
